let scriptPromise = null;
let instance = null;

// Loads Apple's official MusicKit JS once from their CDN.
function loadMusicKitScript() {
  if (scriptPromise) return scriptPromise;
  scriptPromise = new Promise((resolve, reject) => {
    if (window.MusicKit) {
      resolve(window.MusicKit);
      return;
    }
    document.addEventListener("musickitloaded", () => resolve(window.MusicKit), { once: true });
    const script = document.createElement("script");
    script.src = "https://js-cdn.music.apple.com/musickit/v3/musickit.js";
    script.async = true;
    script.onerror = () => {
      scriptPromise = null; // allow a retry on the next call instead of failing forever
      reject(new Error("MusicKit JS failed to load"));
    };
    document.head.appendChild(script);
  });
  return scriptPromise;
}

// Configures MusicKit once with our developer token and returns the singleton instance.
export async function getMusicKitInstance(developerToken) {
  const MusicKit = await loadMusicKitScript();
  if (!instance) {
    MusicKit.configure({
      developerToken,
      app: { name: "DJ Código", build: "1.0.0" },
    });
    instance = MusicKit.getInstance();
  }
  return instance;
}
